import _ from "lodash";
import { FEEDERLISTS, LOCATION } from "../_constants/actionConstants";

const initialState = {
  projLocationLists: {}, // Normalized by projectId
  openLocationDetails: {}, // Normalized by projectId, then by locationId
  miscSessionData: {},
  fetching: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION.ADD:
    case LOCATION.DELETE:
    case LOCATION.EDIT:
    case LOCATION.FETCH_ALL:
    case LOCATION.FETCH_DETAILS:
    case LOCATION.VALIDATE_GENLOCS:
    case LOCATION.GENERIC_REQUEST:
      return { ...state, fetching: true };

    case LOCATION.GENERIC_REQUEST_FULFILLED:
    case LOCATION.GENERIC_REQUEST_REJECTED:
    case LOCATION.VALIDATE_GENLOCS_FULFILLED:
    case LOCATION.VALIDATE_GENLOCS_REJECTED: {
      return { ...state, fetching: false };
    }

    case LOCATION.FETCH_ALL_FULFILLED:
    case LOCATION.ADD_FULFILLED:
    case LOCATION.DELETE_FULFILLED:
    case FEEDERLISTS.FETCH_FULFILLED: {
      const { projectId, projLocationList } = action;
      if (!projectId) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        projLocationLists: {
          ...state.projLocationLists,
          [projectId]: projLocationList,
        },
      };
    }

    case LOCATION.FETCH_DETAILS_FULFILLED: {
      const { projectId, locationId, payload } = action;
      if (!projectId || !locationId || !payload) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        openLocationDetails: {
          ...state.openLocationDetails,
          [projectId]: { ...state.openLocationDetails[projectId], [locationId]: payload },
        },
      };
    }

    case LOCATION.CLEAR_DETAILS: {
      const { projectId, locationId } = action;
      if (
        !projectId ||
        !locationId ||
        !(projectId in state.openLocationDetails) ||
        !(locationId in state.openLocationDetails[projectId])
      )
        return { ...state, fetching: false };

      let openLocationDetails = _.cloneDeep(state.openLocationDetails);
      delete openLocationDetails[projectId][locationId];

      return { ...state, fetching: false, openLocationDetails };
    }

    case LOCATION.EDIT_FULFILLED: {
      const { projectId, locationId, locationDetails, projLocationList } = action;
      if (!projectId || !locationId || !locationDetails || !projLocationList)
        return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        projLocationLists: {
          ...state.projLocationLists,
          [projectId]: projLocationList || state.projLocationLists[projectId] || [],
        },
        openLocationDetails: {
          ...state.openLocationDetails,
          [projectId]: {
            ...state.openLocationDetails[projectId],
            [locationId]: locationDetails,
          },
        },
      };
    }

    default:
      return { ...state };
  }
};
